var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.navitem.submenu)?_c('KTMenuItemText',{attrs:{"navitem":_vm.navitem}}):(_vm._.size(_vm.navitem.submenu) > 0)?_c('KTMenuSubmenu',{attrs:{"submenu":_vm.navitem.submenu,"parentMenu":_vm.navitem}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }